<template>
    <div class="block block-rounded">
        <div class="block-header">
            <h3 class="block-title">Xero Tax Rates</h3>
        </div>
        <div class="block-content">
            <table class="table"  v-if="taxRates.length > 0">
                <thead>
                    <tr>
                        <th>Tax Type</th>
                        <th>Tax Name</th>
                        <th>Tax Percentage</th>
                        <th class="text-center">Enabled</th>
                        <th class="text-center">Default</th>
                    </tr>
                </thead>
                <tbody>
                    <tr  v-for="(taxRate, index) in taxRates" :key="index">
                        <td>{{ taxRate.tax_type }}</td>
                        <td>{{ taxRate.tax_name }}</td>
                        <td>{{ Math.round(taxRate.tax_percentage) }}&#37; </td>
                        <td class="text-center"><input type="checkbox" v-model="taxRate.enabled" /></td>
                        <td class="text-center">
                            <input type="radio" name="tax_rate_is_default" v-model="isDefault" :value="taxRate.id" />
                            <span class="d-block" v-if="taxRate.default === true && hasChanged === true">
                                (Current)
                            </span>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>
                            <button class="btn btn-sm btn-alt-secondary" v-on:click="refetch">Refetch</button>
                        </td>
                        <template v-if="hasChanged !== true">
                            <td colspan="4"></td>
                        </template>
                        <template v-else>
                            <td colspan="2"></td>
                            <td colspan="2" class="text-center">
                                <button class="btn btn-sm btn-primary" v-on:click="saveChanges">Save Changes</button>
                            </td>
                        </template>
                    </tr>
                </tfoot>
            </table>
            <div v-else>
                <p>No tax rates.</p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        currentTaxRates: Array,
        routes: Object,
    },
    data () {
        return {
            hasChanged: false,
            taxRates: [],
            isDefault: 0,
        };
    },
    mounted () {
        this.setRates(this.currentTaxRates);
    },
    watch: {
        isDefault () { this.hasChanged = true; },
        taxRates: {
            deep: true,
            handler: function () { this.hasChanged = true; }
        },
    },
    methods: {
        refetch () {
            axios.get(this.routes.getTaxCode)
                .then((response) => {
                    this.setRates(response.data.taxRates);
                });
        },
        saveChanges () {
            this.taxRates.forEach((taxRate) =>  {
                taxRate.default = (taxRate.id == this.isDefault);
            });
            axios.post(this.routes.saveTaxRates, this.taxRates)
                .then((response) => {
                    this.setRates(response.data.taxRates);

                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'The tax rates have been updated!',
                        showConfirmButton: true,
                    });
                });
        },
        setRates (newRates) {
            this.taxRates = newRates;

            // radio button to pick default means that we have to juggle true and default ID
            const theDefault = this.taxRates.find((taxRate) => taxRate.default === true);

            this.isDefault = (theDefault !== undefined) ? theDefault.id : 0;

            // give it a moment to dodge the watches
            setTimeout(
                () => this.hasChanged = false,
                50
            );
        },
    },
};
</script>
